import { API_URLS } from "../constants";
import { postRequest, getRequest } from "../../../system/server-call";
import responseHandler from "../../../system/server-response-handler";

const { BRAND, CUSTOMER, RESTAURANT_THEME, SURVEY } = API_URLS;

//Saving user survey response
const addSurveyResponse = (body) => {
  return postRequest(CUSTOMER.SURVEY_RESPONSE, body).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

//Function to get theme for survey by brand id
const getThemeByBrandId = (brandId) => {
  return getRequest(`${RESTAURANT_THEME.GET_THEME}/${brandId}`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

//Function to get theme for survey by brand id
const getBrandDetailByBrandId = (brandId) => {
  return getRequest(`${BRAND.GET_BRAND_DETAIL}/${brandId}`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

//Getting customer survey data by encryptedParams
const getSurveyDataByEncryptedParams = (encryptedParams) => {
  return getRequest(`${SURVEY.CUSTOMER}/${encryptedParams}`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const addInvalidOrderInfo = (body) => {
  return postRequest(CUSTOMER.ADD_CUSTOMER_INVALID_ORDER_INFORMATION, body).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const logSurveyInteractionEvent = (body) => {
  return postRequest(SURVEY.LOG, body).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

//Exporting functions for other files
export const customerSurveyService = {
  addSurveyResponse,
  getThemeByBrandId,
  getBrandDetailByBrandId,
  getSurveyDataByEncryptedParams,
  addInvalidOrderInfo,
  logSurveyInteractionEvent,
};
